module.exports = __webpack_public_path__ + "img/Gau.8ada398b.png";